import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-2b1a6823"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bodylogin" };
const _hoisted_2 = {
    key: 0,
    class: "form-container sign-up"
};
const _hoisted_3 = { class: "progress" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Elige si deseas registrarte como vendedor o comprador.", -1 /* HOISTED */));
const _hoisted_5 = { class: "account-type-selection" };
const _hoisted_6 = { class: "account-type-card" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-content" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Vendedor"),
    /*#__PURE__*/ _createElementVNode("p", null, " Vende productos a una gran audiencia y gestiona tu tienda fácilmente. ")
], -1 /* HOISTED */));
const _hoisted_8 = { class: "account-type-card" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-content" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Comprador"),
    /*#__PURE__*/ _createElementVNode("p", null, " Compra productos de calidad a precios competitivos y encuentra ofertas. ")
], -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Completa tu información para registrarte.", -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: ""
}, " Selecciona Estado (Obligatorio) ", -1 /* HOISTED */));
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = { class: "input-group mb-3" };
const _hoisted_15 = ["disabled"];
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "🇻🇪 +58", -1 /* HOISTED */));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "🇺🇸 +1", -1 /* HOISTED */));
const _hoisted_18 = [
    _hoisted_16,
    _hoisted_17
];
const _hoisted_19 = ["disabled"];
const _hoisted_20 = ["disabled"];
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { key: 1 };
const _hoisted_23 = { key: 2 };
const _hoisted_24 = {
    key: 0,
    class: "verification-input-group"
};
const _hoisted_25 = {
    class: "form-group",
    style: { "max-width": "320px" }
};
const _hoisted_26 = { class: "input-group" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "🇻🇪 +58", -1 /* HOISTED */));
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "🇺🇸 +1", -1 /* HOISTED */));
const _hoisted_29 = [
    _hoisted_27,
    _hoisted_28
];
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: ""
}, " Selecciona Tipo de Comercio (Obligatorio) ", -1 /* HOISTED */));
const _hoisted_31 = ["value"];
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Confirmación", -1 /* HOISTED */));
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Revisa tu información antes de registrarte.", -1 /* HOISTED */));
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    id: "registerButton",
    class: "ms-2",
    type: "submit"
}, " Registrarme ", -1 /* HOISTED */));
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    id: "loadingButton",
    type: "button",
    disabled: "",
    class: "ms-2",
    style: { "display": "none" }
}, [
    /*#__PURE__*/ _createElementVNode("span", {
        class: "spinner-border spinner-border-sm me-2",
        role: "status",
        "aria-hidden": "true"
    }),
    /*#__PURE__*/ _createTextVNode(" Registrándote ")
], -1 /* HOISTED */));
const _hoisted_36 = { class: "mobile-only mt-3" };
const _hoisted_37 = { class: "form-container sign-in" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "Iniciar Sesión", -1 /* HOISTED */));
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "usa tu correo electrónico y contraseña", -1 /* HOISTED */));
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", { href: "/recover-passwword" }, "¿Olvidaste tu Contraseña?", -1 /* HOISTED */));
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    id: "loginButton",
    type: "submit"
}, "Iniciar Sesión", -1 /* HOISTED */));
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    id: "loadingButton",
    type: "button",
    disabled: "",
    style: { "display": "none" }
}, [
    /*#__PURE__*/ _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }),
    /*#__PURE__*/ _createTextVNode(" Iniciando sesión ")
], -1 /* HOISTED */));
const _hoisted_43 = { class: "mobile-only mt-3" };
const _hoisted_44 = { class: "toggle-container" };
const _hoisted_45 = { class: "toggle" };
const _hoisted_46 = { class: "toggle-panel toggle-left" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { style: { "color": "white !important" } }, "¡Bienvenido de Nuevo!", -1 /* HOISTED */));
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, " Ingresa tus datos personales para usar todas las funciones del sitio ", -1 /* HOISTED */));
const _hoisted_49 = { class: "toggle-panel toggle-right" };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { style: { "color": "white !important" } }, "¡Hola, Amigo!", -1 /* HOISTED */));
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, " Regístrate con tus datos personales para usar todas las funciones del sitio ", -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_VueRecaptcha = _resolveComponent("VueRecaptcha");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(["container-login", { active: _ctx.isActive }]),
                id: "container"
            }, [
                (_ctx.isActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("form", {
                            id: "registrationForm",
                            onSubmit: _cache[39] || (_cache[39] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", {
                                    class: "progress-bar",
                                    style: _normalizeStyle({ width: _ctx.progress + '%' })
                                }, null, 4 /* STYLE */)
                            ]),
                            _createCommentVNode(" Paso 1: Tipo de Cuenta "),
                            _createElementVNode("div", {
                                class: _normalizeClass(["step step-1", { active: _ctx.currentStep === 1 }])
                            }, [
                                _hoisted_4,
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("label", _hoisted_6, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.form.step1.accountType) = $event)),
                                            value: "1",
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelRadio, _ctx.form.step1.accountType]
                                        ]),
                                        _hoisted_7
                                    ]),
                                    _createElementVNode("label", _hoisted_8, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.step1.accountType) = $event)),
                                            value: "2",
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelRadio, _ctx.form.step1.accountType]
                                        ]),
                                        _hoisted_9
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
                                }, "Siguiente")
                            ], 2 /* CLASS */),
                            _createCommentVNode(" Paso 2: Información Personal "),
                            _createElementVNode("div", {
                                class: _normalizeClass(["step step-2", { active: _ctx.currentStep === 2 }])
                            }, [
                                _hoisted_10,
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.step1.name) = $event)),
                                    type: "text",
                                    placeholder: "Nombre o Razón Social (Obligatorio)",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step1.name]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.form.step1.id) = $event)),
                                    type: "text",
                                    placeholder: "Cédula o RIF (Obligatorio)",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step1.id]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.form.step1.email) = $event)),
                                    type: "email",
                                    placeholder: "Correo Electrónico (Obligatorio)",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step1.email]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.step1.password) = $event)),
                                    type: "password",
                                    placeholder: "Contraseña (Obligatorio)",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step1.password]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.form.step1.confirmPassword) = $event)),
                                    type: "password",
                                    placeholder: "Confirmar Contraseña (Obligatorio)",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step1.confirmPassword]
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[8] || (_cache[8] =
                                        //@ts-ignore
                                        (...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                                }, "Anterior"),
                                _createElementVNode("button", {
                                    class: "ms-2",
                                    type: "button",
                                    onClick: _cache[9] || (_cache[9] =
                                        //@ts-ignore
                                        (...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
                                }, " Siguiente ")
                            ], 2 /* CLASS */),
                            _createCommentVNode(" Paso 3: Dirección y Contacto "),
                            _createElementVNode("div", {
                                class: _normalizeClass(["step step-3", { active: _ctx.currentStep === 3 }])
                            }, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.form.step2.address) = $event)),
                                    type: "text",
                                    placeholder: "Dirección (Obligatorio)",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step2.address]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.form.step2.city) = $event)),
                                    type: "text",
                                    placeholder: "Ciudad (Obligatorio)",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step2.city]
                                ]),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.form.step2.state) = $event)),
                                    required: ""
                                }, [
                                    _hoisted_11,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estados, (ciudad) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: ciudad.estadoId,
                                            value: ciudad.estadoId
                                        }, _toDisplayString(ciudad.nombre), 9 /* TEXT, PROPS */, _hoisted_12));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ], 512 /* NEED_PATCH */), [
                                    [_vModelSelect, _ctx.form.step2.state]
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createCommentVNode(" Prefijo "),
                                        (!_ctx.showVerificationInput)
                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                key: 0,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.form.step2.prefixCelular) = $event)),
                                                class: "form-select",
                                                disabled: _ctx.isPhoneVerified,
                                                style: { "max-width": "90px" }
                                            }, _hoisted_18, 8 /* PROPS */, _hoisted_15)), [
                                                [_vModelSelect, _ctx.form.step2.prefixCelular]
                                            ])
                                            : _createCommentVNode("v-if", true),
                                        _createCommentVNode(" Número celular "),
                                        (!_ctx.showVerificationInput)
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 1,
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.form.step2.cellNumber) = $event)),
                                                type: "tel",
                                                class: "form-control",
                                                placeholder: "Número Celular (Obligatorio)",
                                                disabled: _ctx.isPhoneVerified,
                                                required: ""
                                            }, null, 8 /* PROPS */, _hoisted_19)), [
                                                [_vModelText, _ctx.form.step2.cellNumber]
                                            ])
                                            : _createCommentVNode("v-if", true),
                                        _createCommentVNode(" Botón de verificar "),
                                        _createElementVNode("button", {
                                            class: "btn btn-primary",
                                            type: "button",
                                            onClick: _cache[15] || (_cache[15] = ($event) => (_ctx.requestVerificationCode(_ctx.form.step2.cellNumber))),
                                            disabled: _ctx.isRequestingCode || _ctx.isPhoneVerified || _ctx.timeLeft > 0
                                        }, [
                                            (_ctx.isPhoneVerified)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Verificado ✓"))
                                                : (_ctx.timeLeft > 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Reenviar " + _toDisplayString(_ctx.timeLeft) + "s", 1 /* TEXT */))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_23, "Verificar"))
                                        ], 8 /* PROPS */, _hoisted_20),
                                        _createCommentVNode(" Opción para cambiar el número "),
                                        (_ctx.showVerificationInput)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                type: "button",
                                                onClick: _cache[16] || (_cache[16] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.resetPhoneNumber && _ctx.resetPhoneNumber(...args))),
                                                class: "change-phone-button ms-2"
                                            }, " Cambiar Número "))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createCommentVNode(" Campo de verificación "),
                                    (_ctx.showVerificationInput)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.verificationCode) = $event)),
                                                type: "text",
                                                placeholder: "Ingresa el código de verificación",
                                                maxlength: "6"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, _ctx.verificationCode]
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[18] || (_cache[18] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.verifyCode && _ctx.verifyCode(...args))),
                                                class: "verify-code-button"
                                            }, " Validar ")
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                        _createCommentVNode(" Prefijo "),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.form.step2.prefixWhatsapp) = $event)),
                                            class: "form-select",
                                            style: { "width": "90px", "flex": "none" }
                                        }, _hoisted_29, 512 /* NEED_PATCH */), [
                                            [_vModelSelect, _ctx.form.step2.prefixWhatsapp]
                                        ]),
                                        _createCommentVNode(" Número WhatsApp "),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.form.step2.whatsappNumber) = $event)),
                                            type: "tel",
                                            class: "form-control",
                                            placeholder: "Número WhatsApp",
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.form.step2.whatsappNumber]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[21] || (_cache[21] =
                                        //@ts-ignore
                                        (...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                                }, "Anterior"),
                                _createElementVNode("button", {
                                    class: "ms-2",
                                    type: "button",
                                    onClick: _cache[22] || (_cache[22] =
                                        //@ts-ignore
                                        (...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
                                }, " Siguiente ")
                            ], 2 /* CLASS */),
                            _createCommentVNode(" Paso 4: Información Adicional (Solo para Vendedores) "),
                            _createElementVNode("div", {
                                class: _normalizeClass(["step step-4", { active: _ctx.currentStep === 4 }])
                            }, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.form.step3.landline) = $event)),
                                    type: "tel",
                                    placeholder: "Número Fijo (Opcional)"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step3.landline]
                                ]),
                                (_ctx.form.step1.accountType == 1)
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 0,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.form.step3.commerceType) = $event)),
                                        required: ""
                                    }, [
                                        _hoisted_30,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiposComercio, (tipo) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: tipo.tipoComercioId,
                                                value: tipo.tipoComercioId
                                            }, _toDisplayString(tipo.nombre), 9 /* TEXT, PROPS */, _hoisted_31));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */)), [
                                        [_vModelSelect, _ctx.form.step3.commerceType]
                                    ])
                                    : _createCommentVNode("v-if", true),
                                (_ctx.form.step1.accountType == 1)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.form.step3.website) = $event)),
                                        type: "text",
                                        placeholder: "Página Web (Opcional)"
                                    }, null, 512 /* NEED_PATCH */)), [
                                        [_vModelText, _ctx.form.step3.website]
                                    ])
                                    : _createCommentVNode("v-if", true),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.form.step3.instagramId) = $event)),
                                    type: "text",
                                    placeholder: "ID Instagram (Opcional)"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step3.instagramId]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.form.step3.tiktokId) = $event)),
                                    type: "text",
                                    placeholder: "ID TikTok (Opcional)"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step3.tiktokId]
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[28] || (_cache[28] =
                                        //@ts-ignore
                                        (...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                                }, "Anterior"),
                                _createElementVNode("button", {
                                    class: "ms-2",
                                    type: "button",
                                    onClick: _cache[29] || (_cache[29] =
                                        //@ts-ignore
                                        (...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
                                }, " Siguiente ")
                            ], 2 /* CLASS */),
                            _createCommentVNode(" Paso 5: Representante "),
                            _createElementVNode("div", {
                                class: _normalizeClass(["step step-5", { active: _ctx.currentStep === 5 }])
                            }, [
                                _createCommentVNode(" Campos generales para comprador y vendedor "),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((_ctx.form.step4.facebookName) = $event)),
                                    type: "text",
                                    placeholder: "Nombre en Facebook (Opcional)"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.step4.facebookName]
                                ]),
                                _createCommentVNode(" Estos campos adicionales solo se muestran si es vendedor "),
                                _createElementVNode("div", null, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((_ctx.form.step4.representativeName) = $event)),
                                        type: "text",
                                        placeholder: "Nombre del Representante (Opcional)"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, _ctx.form.step4.representativeName]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((_ctx.form.step4.representativeId) = $event)),
                                        type: "text",
                                        placeholder: "Cédula del Representante (Opcional)"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, _ctx.form.step4.representativeId]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((_ctx.form.step4.representativePhone) = $event)),
                                        type: "tel",
                                        placeholder: "Número de Teléfono del Representante (Opcional)"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, _ctx.form.step4.representativePhone]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((_ctx.form.step4.representativePosition) = $event)),
                                        type: "text",
                                        placeholder: "Cargo del Representante (Opcional)"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, _ctx.form.step4.representativePosition]
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[35] || (_cache[35] =
                                        //@ts-ignore
                                        (...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                                }, "Anterior"),
                                _createElementVNode("button", {
                                    class: "ms-2",
                                    type: "button",
                                    onClick: _cache[36] || (_cache[36] =
                                        //@ts-ignore
                                        (...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
                                }, " Siguiente ")
                            ], 2 /* CLASS */),
                            _createCommentVNode(" Paso 6: Confirmación "),
                            _createElementVNode("div", {
                                class: _normalizeClass(["step step-6", { active: _ctx.currentStep === 6 }])
                            }, [
                                _hoisted_32,
                                _createVNode(_component_VueRecaptcha, {
                                    sitekey: '6LfYC64pAAAAAFGFlo3jUOx6RAgwKNtd8gqSg1BE',
                                    onInput: _ctx.handleRecaptchaInputRegister
                                }, null, 8 /* PROPS */, ["onInput"]),
                                _hoisted_33,
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[37] || (_cache[37] =
                                        //@ts-ignore
                                        (...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                                }, "Anterior"),
                                _hoisted_34,
                                _hoisted_35
                            ], 2 /* CLASS */),
                            _createElementVNode("p", _hoisted_36, [
                                _createTextVNode(" ¿Ya tienes cuenta? "),
                                _createElementVNode("a", {
                                    onClick: _cache[38] || (_cache[38] =
                                        //@ts-ignore
                                        (...args) => (_ctx.showSignIn && _ctx.showSignIn(...args))),
                                    style: { "cursor": "pointer", "color": "#3e6af7", "font-weight": "bold" }
                                }, "Inicia Sesión")
                            ])
                        ], 32 /* NEED_HYDRATION */)
                    ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createCommentVNode(" Iniciar sesión (sin cambios) "),
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("form", {
                                onSubmit: _cache[43] || (_cache[43] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
                            }, [
                                _hoisted_38,
                                _hoisted_39,
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((_ctx.form.login.email) = $event)),
                                    type: "email",
                                    placeholder: "Correo Electrónico",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.login.email]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((_ctx.form.login.password) = $event)),
                                    type: "password",
                                    placeholder: "Contraseña",
                                    required: ""
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.form.login.password]
                                ]),
                                _hoisted_40,
                                _createElementVNode("div", null, [
                                    _createVNode(_component_VueRecaptcha, {
                                        sitekey: '6LfYC64pAAAAAFGFlo3jUOx6RAgwKNtd8gqSg1BE',
                                        onInput: _ctx.handleRecaptchaInputLogin
                                    }, null, 8 /* PROPS */, ["onInput"])
                                ]),
                                _hoisted_41,
                                _hoisted_42,
                                _createElementVNode("p", _hoisted_43, [
                                    _createTextVNode(" ¿No tienes cuenta? "),
                                    _createElementVNode("a", {
                                        onClick: _cache[42] || (_cache[42] =
                                            //@ts-ignore
                                            (...args) => (_ctx.showSignUp && _ctx.showSignUp(...args))),
                                        style: { "cursor": "pointer", "color": "#3e6af7", "font-weight": "bold" }
                                    }, "Regístrate aquí")
                                ])
                            ], 32 /* NEED_HYDRATION */)
                        ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _hoisted_48,
                            _createElementVNode("button", {
                                class: "hidden",
                                onClick: _cache[44] || (_cache[44] =
                                    //@ts-ignore
                                    (...args) => (_ctx.showSignIn && _ctx.showSignIn(...args)))
                            }, "Iniciar Sesión")
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _hoisted_51,
                            _createElementVNode("button", {
                                class: "hidden",
                                onClick: _cache[45] || (_cache[45] =
                                    //@ts-ignore
                                    (...args) => (_ctx.showSignUp && _ctx.showSignUp(...args)))
                            }, "Registrarse")
                        ])
                    ])
                ])
            ], 2 /* CLASS */)
        ])
    ], 64 /* STABLE_FRAGMENT */));
}
